export default __webpack_public_path__ + "static/media/bar-chart.31660712.svg";